import { ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';
import styled from 'styled-components';
import { ReactComponent as IconChevron } from '../../assets/icons/icon-chevron.svg';

export const NextButton = styled(ButtonNext)`
  background: none;
  border: none;
`;

export const BackButton = styled(ButtonBack)`
  background: none;
  border: none;
`;

export const DialogNavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftFacingChevron = styled(IconChevron)`
  transform: rotate(180deg);
`;

export const IconWrapper = styled.div`
  position: relative;
  align-self: center;
  width: 24px;
  height: 24px;

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const NavDots = styled(DotGroup)`
  display: flex;
  flex-grow: 0;
  gap: 12px;

  button {
    width: 16px;
    height: 16px;
    margin: 0;
    padding: 0;
    background-color: #c4c4c4;
    border: none;
    border-radius: 50%;
  }

  button.carousel__dot--selected {
    background-color: #e7131d;
  }
`;
